var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Lista de Files")]),_c('TableList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }